import { Button, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Color } from '../../Common/Color'
import { StopOutlined } from '@ant-design/icons'
import { formatPhoneNumberIntl } from 'react-phone-number-input'

export default function ConfirmedSlot ({ box, slot, onCancel, slotStatus }) {
  const { t } = useTranslation()

  const style = {
    boxShadow: '0px 0px 2px 2px #f2f2f2',
    borderRadius: '1em',
    padding: '1em',
    textAlign: 'center',
    maxWidth: '400px',
    marginTop: '2px'
  }

  return (
    <div>
      <div style={style}>
        {(slotStatus === 'confirmed') &&
          <>
            <div>{t('Public.ConfirmedSlot.description')}</div>
            <Input style={{ margin: '2em 3em', color: Color.red, textAlign: 'center', letterSpacing: '0.5em', width: '170px', fontWeight: 'bold', fontSize: '1.5em' }}
              value={slot.digicode} disabled={true} />
            <Button type="primary" htmlType="submit" onClick={() => onCancel()}>
              {t('Public.ConfirmedSlot.cancel')}
            </Button>
          </>
        }
        {(slotStatus === 'cancel') &&
          <>
            <StopOutlined style={{ fontSize: '32px', margin: '1em' }} />
            <div style={{ color: Color.red }}>{t('Public.ConfirmedSlot.canceled')}</div>
          </>
        }
        {(slotStatus === 'timeout') &&
          <>
            <div>{t('Public.ConfirmedSlot.timeout')}</div>
          </>
        }

      </div>
      {(slotStatus === 'confirmed') &&
        <div style={{ ...style, maxWidth: '400px', marginTop: '1em' }} >
          <p>
            {t('Public.ConfirmedSlot.information.line1', { pcc_phone: formatPhoneNumberIntl(slot.box.pcc_phone) })}
            <a href="mailto:vigilance@laboxmedicale.com" className="btn btn-primary">vigilance@laboxmedicale.com</a>
          </p>
          <p>{t('Public.ConfirmedSlot.information.line2')}</p>
          <p>{t('Public.ConfirmedSlot.information.line3')}</p>
          <p>{t(`Public.ConfirmedSlot.${box?.teleconsulting_company}.description`)}</p>
          <a className="ant-btn css-dev-only-do-not-override-xfszwz ant-btn-primary" href={box.teleconsulting_url} target='_blank' rel="noreferrer">
            <span style={{ fontWeight: 'bold' }}> {t(`Public.ConfirmedSlot.${box?.teleconsulting_company}.button`)} </span>
          </a>
        </div>
      }
    </div >
  )
}
